import FadeTransition from "components/FadeTransition";
import React, { useState } from "react";
import ActiveStar from "/public/svgs/star-active.svg";
import InactiveStar from "/public/svgs/star-inactive.svg";

function RateGame() {
  const [activeStars, setActiveStars] = useState(0);
  const [currentHover, setCurrentHover] = useState(0);

  return (
    <FadeTransition>
      <div className=" inline-flex items-center gap-2  text-left align-middle shadow-xl transition-all">
        <span className="font-medium">Rate this game:</span>
        <div
          className=" flex items-center justify-center gap-2"
          onMouseLeave={() => setCurrentHover(0)}
        >
          {[1, 2, 3, 4, 5].map(index => (
            <StarComponent
              key={index}
              index={index}
              active={activeStars >= index}
              currentHover={currentHover}
              setCurrentHover={setCurrentHover}
              setActiveStars={setActiveStars}
            />
          ))}
        </div>
      </div>
    </FadeTransition>
  );
}

const StarComponent = ({
  index,
  active,
  currentHover,
  setCurrentHover,
  setActiveStars,
}) => {
  // on hover set current hover to the star index
  const handleMouseEnter = index => {
    setCurrentHover(index);
  };

  // on click set active stars to the star index
  const handleClick = index => {
    setActiveStars(index);
  };

  return active || currentHover >= index ? (
    <ActiveStar
      className="cursor-pointer transition-all hover:scale-110"
      width="30px"
      height="30px"
      alt="star"
      onMouseEnter={() => handleMouseEnter(index)}
      onClick={() => handleClick(index)}
    />
  ) : (
    <InactiveStar
      className="cursor-pointer transition-all hover:scale-110"
      width="30px"
      height="30px"
      alt="star"
      onMouseEnter={() => handleMouseEnter(index)}
      onClick={() => handleClick(index)}
    />
  );
};

export default RateGame;
